import LensOrderUrlManager from '../LensOrderUrlManager';

export default class ResetSideFittingOnConditions
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * "right" or "left"
     * @string
     */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        /** @type {LensOrderUrlManager} */
        const lensOrderUrlManager = this.v.lensOrderUrlManager;
        const previousOrder = this.v.sides[this.side].previousOrder;
        const side = this.side;

        // If the URL has no reference, SN or prototype code for the given side,
        // reset that side.
        if(!lensOrderUrlManager.has(side))
        {
            console.log(`${side} side reset: nothing in URL`);

            // Mutation
            this.v.$store.commit('lensOrder/resetFitting', side);

            this.v.sides[side].previousOrder = null;
            return true;
        }

        // If there is a previous order and a lens SN in the URL
        if(previousOrder && lensOrderUrlManager.hasLensSn(side))
        {
            const urlOrderLensSn = lensOrderUrlManager.getLensSn(side);
            const previousOrderLensSn = previousOrder?.article_data?.LENS_SERIAL_NUMBER || null;

            // If previous order lens SN is different from URL order lens SN,
            // user has changed the number in lens SN field => reset side.
            if(urlOrderLensSn != previousOrderLensSn)
            {
                console.log(`${side} side reset: lens SN has changed in URL`);

                // Mutation
                this.v.$store.commit('lensOrder/resetFitting', side);
            }
            else
            {
                console.log(`No reset needed on ${side} side: lens SN has not changed in URL`);
            }

            return true;
        }

        // If there is a previous order and an order reference in the URL
        if(previousOrder && lensOrderUrlManager.hasOrderReference(side))
        {
            const urlOrderReference = lensOrderUrlManager.getOrderReference(side);

            // If the previous order reference is different from the reference
            // in the URL, reset that side.
            if(urlOrderReference != previousOrder.reference)
            {
                console.log(`${side} side reset: order reference has changed in URL`);

                // Mutation
                this.v.$store.commit('lensOrder/resetFitting', side);
            }
            else
            {
                console.log(`No reset needed on ${side} side: order reference has not changed in URL`);
            }

            return true;
        }

        console.log(`No reset needed on ${side} side`);
        return true;
    }
}
